module.exports = __webpack_public_path__ + "static/media/Redeem_Button@3x.43b56f6b.png";